<template>
  <v-dialog
    v-model="show"
    fullscreen
    :overlay="false"
    :transition="false"
    persistent
    width="900px"
    id="dialog"
    class="text-xs-center">
    <v-card id="cardDialog">
      <!-- BACK ARROW -->
      <v-icon @click="$emit('cancel-loading')" class="icon-size-1 icon-transform-1">arrow_back</v-icon>
      <v-layout
        row
        wrap
        align-center
        class="text-xs-center font-number">
        <v-flex id="descripPOS" xs12>{{ $t("loading") }}</v-flex>
        <v-flex xs4 />
        <v-flex xs4>
          <v-progress-linear :indeterminate="true" color="info" height="8" />
          {{ loadingProgress }} %
        </v-flex>
        <v-flex xs4 />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    loadingProgress: {
      type: String,
      default: ""
    }
  }
};
</script>

<style>
#descripPOS {
  margin-top: 400px;
}

#cardDialog {
  background-color: black;
}

#dialog {
  overflow: hidden;
  background: none !important;
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/player/LoadingDialog.vue